export const numeroBmMixin = {
  name: "numeroBmMixin",
  methods: {
    adicionarZero(numero) {
      if(typeof(numero) != 'string'){
        numero = numero.toString();
      }
      return numero.padStart(7, "0")
    },

    removerZero(numero) {
      if(typeof(numero) != 'string'){
        numero = numero.toString();
      }
      while (numero.charAt(0) === '0') {
        numero = numero.substring(1);
      }
      return numero
    }
  },
};